import { isValidUrl, notifyMissingFields } from '../../../helpers/utils.helper';
import type { AdminSPOrganization } from './adminSPOrganizationsSlice';

export const validateAdminSPOrganization = (adminSPOrganization: AdminSPOrganization) => {
  const missingRequiredFields = [];
  if (!adminSPOrganization.name) missingRequiredFields.push('name');
  if (!adminSPOrganization.org_code) missingRequiredFields.push('organization');
  if (adminSPOrganization.internal === undefined) missingRequiredFields.push('internal');
  if (adminSPOrganization.website) {
    if (!/^https?:\/\//.test(adminSPOrganization.website)) {
      adminSPOrganization.website = 'https://' + adminSPOrganization.website;
    }
    if (!isValidUrl(adminSPOrganization.website)) missingRequiredFields.push('website');
  }
  if (
    adminSPOrganization.phone_number &&
    !RegExp('\\(?\\d{3}\\)?-? *\\d{3}-? *-?\\d{4}').test(adminSPOrganization.phone_number)
  ) {
    missingRequiredFields.push('phone_number');
  }

  if (missingRequiredFields.length > 0) {
    return notifyMissingFields(missingRequiredFields);
  } else {
    return true;
  }
};
